'use client';

import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import Icon from '@/components/ui/AppIcon';

interface LanguageSwitcherProps {
  className?: string;
  variant?: 'default' | 'mobile';
}

const LanguageSwitcher = ({ className = '', variant = 'default' }: LanguageSwitcherProps) => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'es' : 'en');
  };

  if (variant === 'mobile') {
    return (
      <button
        onClick={toggleLanguage}
        className={`flex items-center space-x-2 px-4 py-3 rounded-lg text-left transition-all duration-250 text-text-primary hover:bg-muted hover:text-primary ${className}`}
        aria-label="Switch language"
      >
        <Icon name="GlobeAltIcon" size={20} className="text-primary" />
        <span className="font-body font-medium">
          {language === 'en' ? 'Español' : 'English'}
        </span>
      </button>
    );
  }

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center space-x-2 px-3 py-2 rounded-full bg-background/80 hover:bg-background transition-all duration-250 border border-border ${className}`}
      aria-label="Switch language"
      title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
    >
      <Icon name="GlobeAltIcon" size={16} className="text-primary" />
      <span className="font-body font-medium text-sm text-primary">
        {language === 'en' ? 'ES' : 'EN'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;